import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryRequestCancelOrderEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryRequestCancelOrderContentProps = {
  event: OrderDetailsHistoryEntryRequestCancelOrderEvent;
};

const OrderDetailsHistoryEntryRequestCancelOrderContentComponent: FC<
  OrderDetailsHistoryEntryRequestCancelOrderContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .requestCancelOrderEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryRequestCancelOrderContentComponent;
